/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import { ApiPrefixV1, ApiV1Base } from 'util/icwUtility';
import Request from './request';

export const apiGetProductCustomTags = (params) => {
  return Request.call({
    url: `/micro/products/custom-tags`,
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetProductCustomCategories = (params) => {
  return Request.call({
    url: `/micro/products/custom-categories`,
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiCreateProductCustomCategories = (data) => {
  return Request.call({
    url: `/micro/products/custom-categories`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiCreateProductCustomTags = (data) => {
  return Request.call({
    url: `/micro/products/custom-tags`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiProductDetailsComplianceData = ({ key, action, id, data, entity }) => {
  const url = `/micro/${entity}/${id}/compliance-data/${key}`;
  const method = action === 'add' ? (!!data.id ? 'PUT' : 'POST') : 'GET';
  const obj = {
    url,
    method,
  };
  if (action === 'add') {
    obj.data = data;
    if (data.id) {
      obj.url = `/micro/${entity}/${id}/compliance-data/${key}/${data.id}`;
      delete obj.data.id;
    }
  } else if (action === 'archive') {
    obj.url = `/micro/${entity}/${id}/compliance-data/${key}/${data.id}/archive`;
    obj.method = 'POST';
  } else if (action === 'unarchive') {
    obj.url = `/micro/${entity}/${id}/compliance-data/${key}/${data.id}/unarchive`;
    obj.method = 'POST';
  } else if (action === 'delete') {
    obj.url = `/micro/${entity}/${id}/compliance-data/${key}/${data.id}`;
    obj.method = 'DELETE';
  } else if (action === 'renew') {
    obj.method = 'POST';
    obj.data = data;
    if (data.id) {
      obj.url = `/micro/${entity}/${id}/compliance-data/${key}/${data.id}/renew`;
      delete obj.data.id;
    }
  } else {
    obj.params = data;
  }
  return Request.call({
    ...obj,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
